import { render, staticRenderFns } from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=template&id=be01db76&scoped=true"
import script from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=style&index=0&id=be01db76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be01db76",
  null
  
)

export default component.exports